export default __webpack_public_path__ + "static/media/java.a8013985.jpg";